"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { motion } from "motion/react";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/CdnIcon.js";
import { NotificationBadge } from "../../NotificationBadge/NotificationBadge.js";
import { useToolbarContext } from "../Toolbar.context.js";
import { toolbarButtonVariantKeys, toolbarButtonVariants } from "./ToolbarButton.variants.js";
const ToolbarButton_ToolbarButton = /*#__PURE__*/ forwardRef(function({ as = 'button', icon = 'calendar_month', label, showLabel = true, notificationCount, className, onClick, emphasis: emphasisProp, animate, ...props }, ref) {
    const { emphasis: contextEmphasis } = useToolbarContext();
    const emphasis = emphasisProp ?? contextEmphasis ?? 'medium';
    const hasLabel = Boolean(label);
    const hasNotification = 'number' == typeof notificationCount && notificationCount > 0;
    const { root, flexSlot, iconSlot, labelSlot } = toolbarButtonVariants({
        as,
        emphasis,
        animate,
        hasLabel
    });
    const domProps = cleanProps(props, toolbarButtonVariantKeys);
    const labelContent = animate ? hasLabel && /*#__PURE__*/ jsx(motion.p, {
        className: labelSlot(),
        initial: false,
        animate: {
            opacity: showLabel ? 1 : 0,
            height: showLabel ? 'auto' : 0
        },
        transition: {
            duration: 0.15,
            ease: 'easeOut'
        },
        children: label
    }) : hasLabel && showLabel && /*#__PURE__*/ jsx("p", {
        className: labelSlot(),
        children: label
    });
    const iconElement = icon && /*#__PURE__*/ jsx(CdnIcon, {
        className: iconSlot(),
        iconName: icon,
        size: "24"
    });
    const content = /*#__PURE__*/ jsxs("div", {
        className: flexSlot(),
        children: [
            hasNotification ? /*#__PURE__*/ jsx(NotificationBadge, {
                count: notificationCount,
                size: "sm",
                offsetTop: -4,
                offsetRight: -8,
                emphasis: emphasis,
                children: iconElement
            }) : iconElement,
            labelContent
        ]
    });
    if ('button' === as) return /*#__PURE__*/ jsx("button", {
        ref: ref,
        type: "button",
        className: cn(root(), className),
        onClick: onClick,
        ...domProps,
        children: content
    });
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        className: cn(root(), className),
        ...domProps,
        children: content
    });
});
export { ToolbarButton_ToolbarButton as ToolbarButton };
